$(document).ready(function() {
    $('#fullpage').fullpage({
        controlArrows: false,
        autoScrolling: false,
        touchSensitivity: 100,
        anchors:['firstPage'],
        responsiveWidth: 1140,
        afterResponsive: function(isResponsive){
        }
    });

    // SIDE NAV
    $('.menu--nav').click(function() {
        $(this).toggleClass('active');
        $('.sidenav').toggleClass('opened');
        $('body').toggleClass('overflow');
    });
    $('.menu--item a').click(function() {
        $('.sidenav').removeClass('opened');
        $('.menu--nav').removeClass('active');
        $('body').removeClass('overflow');
    });

    // TOP NAV
    $('.menu--nav_top').click(function() {
        $(this).toggleClass('active');
        $('.topnav').toggleClass('opened');
        $('.whap').toggle();
    });

    // SLIDERS
    $('.slider-section-j').slick({
        dots: false,
        arrows: true,
        fade: true,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
              breakpoint: 480,
              settings: {
                dots: true,
                arrows: false 
              }
            },
        ]
    });
    $('.slider-section-g, .slider-section-k').slick({
        dots: true,
        arrows: true,
        fade: true,
    }); 

    $('.slick-dots li button').each(function(){
        if (
            ( !$(this).is('#slick-slide-control11') && !$(this).attr('tabindex', '0')  ) ) {
                $('.vertical1').addClass("active")
        } 
    });

    // ODS
    $('.list--ods li').hover(function() {
            var value = $(this).attr('data-src');
            $('.box--ods img').attr('src', value);
        }
    );
    $('.list--ods li').mouseleave(function() {
        $('.box--ods img').attr('src', 'assets/img/chart--ods_lg.svg');
    });

    // DOWNLOAD COUNT
    $('#download').click(function(event) {
        event.preventDefault();
          var redirectUrl = $(this).attr('href');
          $.ajax({
              url: "downloads.php",
              success: function(response) {
                  if (response = 'success') {
                      var count = $('#count').html();
                      $('#count').html(parseFloat(count) + 1);
                      
                      window.location.href = redirectUrl; 
                  }
              }
          });
        return true;
    });
    $.ajax({
        url: "get-downloads.php",
        success: function(data) {
            var data = JSON.stringify(data, null, 4);
            var data = $.parseJSON(data);
    
            $('#count').html(data.count);
        }
    });

    // VIEW COUNT
    $.getJSON("https://api.countapi.xyz/hit/jobs.gonta.com.br/:PATHNAME:", function(response) {
        $("#visits").text(response.value);
    });



    (function($) {

        /**
         * Copyright 2012, Digital Fusion
         * Licensed under the MIT license.
         * http://teamdf.com/jquery-plugins/license/
         *
         * @author Sam Sehnert
         * @desc A small plugin that checks whether elements are within
         *     the user visible viewport of a web browser.
         *     only accounts for vertical position, not horizontal.
         */
      
        $.fn.visible = function(partial) {
          
            var $t            = $(this),
                $w            = $(window),
                viewTop       = $w.scrollTop(),
                viewBottom    = viewTop + $w.height(),
                _top          = $t.offset().top,
                _bottom       = _top + $t.height(),
                compareTop    = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;
          
          return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
      
        };
          
      })(jQuery);
      
      $(window).scroll(function(event) {
        
        $(".section-f .slide2").each(function(i, el) {
          var el = $(el);
          if (el.visible(true)) {
            el.addClass("fadeIn");
          } else {
            el.removeClass("fadeIn");
          }
        });
        
      });

    $(".slide aside").height($(".fp-slidesContainer").height());

});